import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { CONTACT_EMAIL, SITE_NAME } from '@/components/feature/Seo';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-secondary-950 text-background-100">
      <div className="mx-auto max-w-content px-4 md:px-6 py-12 md:py-16">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-lg text-secondary-950">
                <i className="ri-emotion-laugh-line" aria-hidden="true" />
              </span>
              <span className="font-heading text-2xl text-background-50">{SITE_NAME}</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200">
              把散落在各个角落的玩梗现场整理成册。热评、弹幕、名场面、群聊高能，都在这里，找梗不用再东翻西找。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="rounded-full bg-secondary-900 px-3 py-1 text-xs text-background-200">
                每日更新热榜
              </span>
              <span className="rounded-full bg-secondary-900 px-3 py-1 text-xs text-background-200">
                开放投稿
              </span>
              <span className="rounded-full bg-secondary-900 px-3 py-1 text-xs text-background-200">
                无需注册
              </span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-lg text-accent-300">热门分类</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/topics?category=${cat.slug}`}
                    className="text-background-200 transition-colors hover:text-background-50"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-lg text-accent-300">网站导航</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-background-200 transition-colors hover:text-background-50">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/topics" className="text-background-200 transition-colors hover:text-background-50">
                  话题分类
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-background-200 transition-colors hover:text-background-50">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-background-200 transition-colors hover:text-background-50">
                  联系我们
                </Link>
              </li>
              <li>
                <a
                  href={`mailto:${CONTACT_EMAIL}`}
                  rel="nofollow"
                  className="text-background-200 transition-colors hover:text-background-50"
                >
                  {CONTACT_EMAIL}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-900 pt-6 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {SITE_NAME} · 围观最热闹的玩梗现场</p>
          <p className="text-background-400">
            站内内容均为网友公开讨论的整理与二次创作，仅供围观娱乐。
          </p>
        </div>
      </div>
    </footer>
  );
}